import { useDocumentUploadEntities, useResetDocumentUploadEntities } from '@izimi/core';
import { useModules } from '@izimi/modules';

import { useModalStore } from '../modals';
import { DocumentTableRowUpload } from '../Table/rows/DocumentTableRowUpload';
import { UploadZoneView } from './UploadZoneView';

export const UploadZone = () => {
  const {
    vault: { useVaultInfo },
  } = useModules();
  const { vaultInfo } = useVaultInfo();
  const documentUploadEntities = useDocumentUploadEntities();
  const resetDocumentUploadEntities = useResetDocumentUploadEntities();
  const { showModal } = useModalStore();

  return (
    <UploadZoneView
      documentUploadEntities={documentUploadEntities}
      onClose={resetDocumentUploadEntities}
      onAbort={() => showModal({ type: 'abortUpload' })}
      renderDocumentUploadRow={(documentUploadEntity) => (
        <DocumentTableRowUpload
          documentUploadEntity={documentUploadEntity}
          maxSizeFormatted={vaultInfo?.maxSizeFormatted}
        />
      )}
    />
  );
};
